import React from "react";
import { SurveySegment } from "../../../../../../amorg-common";
import { Flex } from "../../../../../../designSystem/compositeComponents/FlexHelpers";
import { InfoChip } from "../../../../../../designSystem/Chip";

type SegmentListChipListProps = {
    identifier: string,
    segments: SurveySegment[]
};
export function SegmentListChipList (props: SegmentListChipListProps): JSX.Element
{
    return (
        <Flex gap={4} style={{ flexWrap: 'wrap' }}>
            {props.segments.map((s, index) =>
                <InfoChip key={props.identifier + '-' + index} variant="filled">
                    {s.value}
                </InfoChip>
            )}
        </Flex>
    );
}